module.exports = __webpack_public_path__ + "icons/original/small/small-d3.402ab38c15f0b6e6d5bf8c21c1966cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d3.png
// module id = Dvz/
// module chunks = app